/*
by zhou 2016/10/19
 */
"use strict";
angular.module('newWindowPlanDispatchLeiXingModule', [])
    .controller('newWindowPlanDispatchLeiXingCtrl', ['$scope', "$modalInstance", "Params",
        function($scope, $modalInstance, Params) {
            initStatus();
            /**
             * [initStatus description:初始化状态]
             */
            function initStatus() {
                $scope.status.windows = angular.copy(Params);
                if (Params.OPERID === 0) {
                    $scope.status.windows.PARAM = "";//设置这个参数是无奈之举，防止上传参数出现undefind 添加if判断是为了在修改数据的时候防止这个参数为空
                }
                $scope.title = Params.OPERID === 0 ? "新建状态" : "修改状态";
            }
            /**
             * [cancel description:取消]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
            /**
             * [confirm description:确定]
             */
            $scope.confirm = function() {
                $modalInstance.close($scope.status.windows);
            };
        }
    ]);
